import {
  BpkButtonV2,
  BUTTON_TYPES,
} from '@skyscanner/backpack-web/bpk-component-button';
import ThumbsUpIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/thumbs-up';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { I18nService } from '@shared/types/i18n';

import STYLES from './HelpfulButton.module.scss';

import useHotelReviewsHelpful from '@hotels-hotel-detail/data-access/stores/useHotelReviewsHelpful';
import { withI18n } from '@shared/ui/contexts/i18n';

const getClassName = cssModules(STYLES);

type Props = {
  i18n: I18nService;
  partner: string;
  locale: string;
  hotelId: string;
  partnerReviewId: string;
};

const HelpfulButton = ({
  hotelId,
  i18n,
  locale,
  partner,
  partnerReviewId,
}: Props) => {
  const { isAnimating, isHelpful, toggleHelpful } = useHotelReviewsHelpful({
    partner,
    locale,
    hotelId,
    partnerReviewId,
  });

  return (
    <BpkButtonV2
      type={BUTTON_TYPES.link}
      onClick={toggleHelpful}
      className={getClassName(
        'HelpfulButton',
        !isHelpful && 'HelpfulButton__unselected',
      )}
      aria-pressed={isHelpful}
    >
      <ThumbsUpIcon
        className={getClassName(isAnimating && 'HelpfulButton__iconAnimation')}
      />
      {i18n.translate(
        isHelpful
          ? 'Helpful_button_label'
          : 'Helpful_button_label_with_question_mark',
      )}
    </BpkButtonV2>
  );
};

export default withI18n(HelpfulButton);
